import { errorLoading, loaded, responseHandler, errorGetStatus, tokenInterceptor } from '../manager/HttpManager'
import { fetchLogoutAction } from './AuthWS'
import Constants from '../constants/Constants'

let urlServer = Constants.UrlsConstants.urlServer

export const configurationWS = (state = { navigationType: '' }, action) => {
  switch (action.type) {
    case Constants.ActionsConstants.CONFIGURATION.SET_NAVIGATION_TYPE:
      return Object.assign({}, state, { navigationType: action.datas })
    default:
      return state
  }
}

export const setNavigationType = (data) => {
  return {
    type: Constants.ActionsConstants.CONFIGURATION.SET_NAVIGATION_TYPE,
    datas: data,
  }
}

/**
 * Group app navigation configuration
 */
export function fetchNavigationTypeAction (dispatch, appid, navigationType) {
  /**
   * Get the navigation type of an application
   * /app/detail/1/APPLICATION_TYPE_MENU?login=
   */
  function GetNavigationType () {
    // build url
    let entryPoint = Constants.UrlsConstants.appsEntryPoint
    let method = Constants.MethodsWSConstants.APPS.DETAIL_APP
    let queryParams = appid + '/' + Constants.AppsConstants.CONFIGURATION.APPLICATION_TYPE_MENU

    // dispatch(loading(method))
    fetch(urlServer+entryPoint+method+queryParams, {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        // dispatch(loaded(method))
        dispatch(setNavigationType(data))
      })
      .catch(error => {
        // dispatch(errorLoading(method))
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
          // window.location.href='/'
        }
      })
  }

 /**
  * Update the current app navigation configuration
  * /app/update/APPLICATION_TYPE_MENU?login
  */
  function UpdateNavigationType () {
    // build url
    let entryPoint = Constants.UrlsConstants.appsEntryPoint
    let method = Constants.MethodsWSConstants.APPS.UPDATE_APP
    let queryParams = Constants.AppsConstants.CONFIGURATION.APPLICATION_TYPE_MENU
    let dataNav = {'id': appid, 'menuType': navigationType.menuType, 'theme': navigationType.theme,
      'fab': navigationType.fab, 'menuPictureHeader': navigationType.menuPictureHeader,
      'menuHeaderAction': navigationType.menuHeaderAction, 'tabBar': navigationType.tabBar}

    // dispatch(loading(method))
    fetch(urlServer+entryPoint+method+queryParams, {
      method: 'PUT',
      body: JSON.stringify(dataNav),
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(loaded('Error.Croutons.saveSuccess'))
        // dispatch(loaded(method))
        GetNavigationType()
      })
      .catch(error => {
        // dispatch(errorLoading(method))
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
          // window.location.href='/'
        }
      })
  }
  return {
    GetNavigationType,
    UpdateNavigationType,
  }
}
